export default __webpack_public_path__ + "static/1breakfastbarbench-638613fbb55bdd93368d7d186c2f48df.png";